import { render, staticRenderFns } from "./realm.vue?vue&type=template&id=a0f538c6&scoped=true&"
import script from "./realm.vue?vue&type=script&lang=js&"
export * from "./realm.vue?vue&type=script&lang=js&"
import style0 from "./realm.vue?vue&type=style&index=0&id=a0f538c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f538c6",
  null
  
)

export default component.exports